import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { ProfilesCrumbs } from '../constants';
import ProfileForm, { FormProfile } from 'system/components/profiles/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';

const ProfilesNewPage = (): React.ReactElement => {
  const { post: insertProfile } = useHttpFetch(`${__MANAGEMENT_API_URL__}/profili`);
  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues?: FormProfile) => {
      insertProfile({
        nome: formValues?.name,
        note: formValues?.lastUpdate,
        funzioni: (formValues?.functionalities || []).map((element) => ({
          key: {
            codice: element.id,
          },
          codiceEnte: element.institutionCode,
          nome: element.description,
          entita: element.entity,
          evento: element.event,
        })),
        gruppi: (formValues?.groups || []).map((element) => ({
          key: {
            codice: element.id,
          },
          codiceEnte: element.institutionCode,
          nome: element.description,
        })),
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/profili');
      });
    },
    [insertProfile, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...ProfilesCrumbs, { name: 'Nuovo Profilo' }]} />
      <ProfileForm
        title="Nuovo Profilo"
        insert
        onOk={onSubmit}
        onCancel={() => {
          navigate('/sistema/profili');
        }}
      />
    </Fragment>
  );
};

ProfilesNewPage.displayName = 'Profile new page component';

export default ProfilesNewPage;
